import { produce } from "immer";
import {
  FETCH_NOTIFICATION,
  FETCH_NOTIFICATION_FAILURE,
  FETCH_NOTIFICATION_SUCCESS,
  ADD_NOTIFICATION,
  ADD_NOTIFICATION_SUCCESS,
  ADD_NOTIFICATION_FAILURE,
  TOGGLE_NOTI_MODAL,
} from "./constants";

export const initialState = {
  isFetchingNotification: false,
  notifications: [],
  isAddingNotification: false,
  notiModal: { open: false },
};

const NotificationReducer = (state = initialState, action) =>
  produce(state, (draft) => {
    switch (action.type) {
      case FETCH_NOTIFICATION:
        draft.isFetchingNotification = true;
        draft.notifications = [];
        break;
      case FETCH_NOTIFICATION_SUCCESS:
        draft.isFetchingNotification = false;
        draft.notifications = action.payload;
        break;
      case FETCH_NOTIFICATION_FAILURE:
        draft.notifications = [];
        draft.isFetchingNotification = false;
        break;
      case ADD_NOTIFICATION:
        draft.isAddingNotification = true;
        break;
      case ADD_NOTIFICATION_SUCCESS:
        draft.isAddingNotification = false;
        break;
      case ADD_NOTIFICATION_FAILURE:
        draft.isAddingNotification = false;
        break;
      case TOGGLE_NOTI_MODAL:
        draft.notiModal = action.payload;
        break;
      default:
        return state;
    }
  });

export default NotificationReducer;
